import { render } from "./TaxonPicker.vue?vue&type=template&id=1cd47366&scoped=true&ts=true"
import script from "./TaxonPicker.vue?vue&type=script&lang=ts"
export * from "./TaxonPicker.vue?vue&type=script&lang=ts"

import "./TaxonPicker.vue?vue&type=style&index=0&id=1cd47366&scoped=true&lang=css"

import exportComponent from "C:\\Users\\nyffeler\\IdeaProjects\\data_tools\\Branches\\data_tools\\131\\frontend-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cd47366"]])

export default __exports__